<template>
  <AgencyPage />
</template>

<script>
// import LandingPage from '~/components/landingPage/index'
import AgencyPage from '~/components/landingPage/agency'
export default {
  layout: 'empty',
  components: {
    AgencyPage
  }
}
</script>
